<template>
  <div class="main-page  page-tj-people">
    <Menu title="调解人员查询" :home="true">
      <template slot="left-link">
        <a href="javascript:;" @click="goPrevious"></a>
      </template>
    </Menu>
    <div class="container-flex">
      <div class="search-content">
        <div class="search-panel  ">

          <div class="input-panel">
            <input type="text" v-model="searchForm.keyword" placeholder="中文姓名/执业证号">
            <button class="flex justify-center items-center flex-shrink-0 text-lg" @click="getSearch"> <img src="https://qiniu.laway.cn/yn/2025/02/08/f8648f40e5c411ef99f8b4055d0b07be.svg" class="mr-[4px]"> 搜索</button>
          </div>
          <div class="search-params  ">
            <div class="hts">高级检索</div>
            <div class="params-item">
              <div class="params-item-title">所在地区：</div>
              <div class="params-item-content">

                <div @click="setCity(city, key)" :class="['radio-item  ',{active:searchForm.city==key}]" v-for="(city, key) in arealist" :key="'key-c' + key">
                  <input type="radio" v-model="searchForm.code">
                  {{city.alias}}
                </div>
              </div>
            </div>
            <div class="params-item" v-if="arealist[searchForm.city]">
              <div class="params-item-title">所在区县：</div>
              <div class="params-item-content">

                <div @click="searchForm.code = key;getSearch()" :class="['radio-item  ',{active:searchForm.code==key}]" v-for="(v, key) in arealist[searchForm.city].children" :key="'key-c' + key">
                  <input type="radio" v-model="searchForm.code">
                  {{v.alias}}
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="p-list-panel">

          <div class="p-list ">
            <div class="item" v-for="(item, index) in list" :key="'res'+ index" @click="previewPeople(item)">
              <img :src="item.photo ||'/img/ui/lawyer_avatar.png'" alt="">

              <div class="content">
                <div class="name">
                  {{item.name}}
                </div>
                <div>
                  所在机构：{{ item.org_name }}
                </div>
                <div>
                  所属地区：{{ item.area_name }}
                </div>

                <div>
                  首次担任调解员年份：{{ item.scdrtjynf || '-' }}
                </div>
              </div>

            </div>
            <div v-if="loadOver &&  list.length &&pageSize>page" class="more-btn">

              <button @click="getMore">加载更多</button>
            </div>
            <div v-if="loadOver&& !list.length" class="empty-info">
              <img src="https://qiniu.laway.cn/yn/2020/11/10/e0a5a0ac22fe11eb8cd1b4055d0b07be.png" class="mx-auto" alt="">
              <p>没有搜索到~</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <org-people :currentstaff="currentstaff" :showStaff="showStaff" orgtype="2" @close="showStaff = false" />

  </div>
</template>
<script>
import Menu from '@/components/Menu'
import OrgPeople from '@/components/org-people-dialog.vue'
import { MEDIATOR_INQUIRY } from '@/datas/constants/statistics.js'

export default {
  components: { Menu, OrgPeople },
  data () {
    return {
      showStaff: false,
      currentstaff: '',
      searchForm: {
        city: '',
        code: '',
        keyword: '',
      },
      list: [],
      loadOver: false,
      step: 1,
      page: 1,
      currentstaff: false,
      showStaff: false
    }
  },
  computed: {
    arealist () {
      return this.$store.state.device.area
    },
  },
  created () {
    const pointCode = this.$point.code;
    const area = this.arealist[pointCode];
    const children = area && area.children;
    this.$root.getStatistics(MEDIATOR_INQUIRY)

    const targetArea = children ? area : this.arealist[Object.keys(this.arealist)[0]];
    this.searchForm.city = children ? pointCode : Object.keys(this.arealist)[0];
    this.searchForm.code = Object.keys(targetArea.children || targetArea)[0];
    this.getList()
  },
  methods: {
    goPrevious () {
      if (this.step === 1) {
        this.$router.go(-1)
      } else {
        this.step--
      }
    },
    getMore () {
      this.page++
      this.loadOver = false
      this.getList()
    },
    getSearch () {
      this.page = 1
      this.loadOver = false
      this.getList()
    },
    async getList () {
      let { keyword, city, code } = this.searchForm;
      let result = await this.$api.getOrganizationEmployee({
        code: code || city,
        keyword,
        org_type: 2,
        per_page: 100,
        page: this.page
      })
      if (!result.status) return
      this.pageSize = result.num_pages
      const arr = result.items || []
      this.list = this.page > 1 ? [...this.list, ...arr] : arr
      this.loadOver = true
      this.step = 2
    },
    previewPeople (item) {
      this.currentstaff = item
      this.showStaff = true
    },
    setCity (city, key) {
      this.searchForm.city = key
      this.searchForm.code = Object.keys(city.children)[0]
      this.getSearch()
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-tj-people
  color #fff
  .search-content
    display flex
    overflow hidden
    height 100%
    color #333
    .search-panel
      width 25%
      padding 0.2rem
      background #fff
      height 100%
      .input-panel
        position relative
        margin-top 0.1rem
        border-radius 0.1rem
        overflow hidden
        display flex
        background #fff
        border 1px solid #378bf8
        input
          font-size 0.18rem
          padding 0 0.2rem
          flex 1
          border 0
        input:-moz-placeholder, input::-moz-placeholder
          color #999
          opacity 1
        input:-ms-input-placeholder
          color #999
        input::-webkit-input-placeholder
          color #999
        button
          width 1rem
          height 0.45rem
          font-size 0.2rem
          color #fff
          background-color #2a69e0
      .search-params
        padding-top 0.2rem
        .hts
          font-size 0.2rem
          font-weight bold
          letter-spacing 1px
          color #333
          margin-bottom 0.1rem
        .params-item
          display flex
          align-items baseline
          margin-bottom 0.1rem
          .params-item-title
            font-size 0.18rem
            width 0.9rem
            flex-shrink 0
            text-align right
          .params-item-content
            flex 1
            display flex
            font-size 0.22rem
            flex-wrap wrap
            padding-left 0.1rem
      .radio-item
        letter-spacing 1px
        margin-bottom 0.1rem
        font-size 0.18rem
        margin-right 0.2rem
        input
          width 12px
          height 12px
          cursor pointer
          margin-right 2px
          border-radius 2px
          border solid 1px #e6e6e6
        &.active
          color #f29530
          input
            position relative
            border-color #f29530
            &::after
              content ''
              position absolute
              top -1px
              left 1px
              width 5px
              height 8px
              border-left solid #f29530 1px
              border-top solid #f29530 1px
              transform rotate(225deg)
    .p-list-panel
      flex 1
      overflow hidden
      .p-list
        max-height 100%
        overflow-y auto
        display flex
        justify-content space-between
        flex-wrap wrap
        padding 0 0.4rem 0 0.4rem
        .item
          width 49%
          background #fff
          border-radius 0.05rem
          border 0.01rem solid #eee
          padding 0.25rem
          display flex
          margin-bottom 0.3rem
          font-size 0.16rem
          color #808080
          &:active
            background #f7f7f7
          img
            width 1rem
            object-fit cover
            margin-right 0.2rem
          .name
            font-size 0.24rem
            color #333
            margin 0.15rem 0 0.1rem
      .more-btn
        width 100%
        padding 0 0 0.2rem
        text-align center
        button
          width 2rem
          background #fff
          font-size 0.2rem
          padding 0.1rem
          border-radius 0.1rem
          color #2a69e0
      .empty-info
        text-align center
        color #fff
        width 100%
        padding-top 1rem
        img
          margin-bottom 0.3rem
</style>